var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pdm-user-name-select" },
    [
      _c(
        "el-select",
        {
          attrs: {
            "collapse-tags": "",
            placeholder: _vm.placeholder,
            size: _vm.size,
            multiple: _vm.multiple,
            disabled: _vm.disabled,
            clearable: "",
            filterable: "",
            remote: _vm.remote,
          },
          on: {
            "remote-method": _vm.remoteMethod,
            change: _vm.change,
            clear: _vm.clear,
          },
          model: {
            value: _vm.insValue,
            callback: function ($$v) {
              _vm.insValue = $$v
            },
            expression: "insValue",
          },
        },
        _vm._l(_vm.options, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: { label: item.personName, value: item.id },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }